import React, { useEffect, useState } from 'react';
import axios from 'axios';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { API_KEYS } from '../../__constants__';
import { trimLeadingZeros } from '../../utils/utilities';
import { setAppRedirectStatus } from '../../actions/routerActions';
import { APP_REDIRECT_STATUS } from '../../actions/types';
import { useRouter } from 'next/router';
import PageHeadOptionalMetaTags from '../PageHeadOptionalMetaTags';

const ID_VARIABLE = {
    professionals: 'user',
    firm: 'firmPermalink',
    network: 'firmPermalink'
};

export function validatePermalink(permalink, props, type) {
    if (type === 'professionals') {
        const user = _.get(props, ['match', 'params', ID_VARIABLE[type]]);
        const region = _.get(props, 'match.params.region');
        const vertical = _.get(props, 'match.params.type');

        return permalink === `${vertical}/${region}/${user}`;
    } else if (type === 'firm') {
        const firm = _.get(props, [ID_VARIABLE[type]]);

        return permalink === `firm/${firm}`;
    } else if (type === 'network') {
        const network = _.get(props, [ID_VARIABLE[type]]);
        return permalink === `network/${network}`;
    }

    return false;
}

export const PermalinkRedirection = (props) => {
    const {
        error = false,
        loading = false,
        redirect = '',
        children,
    } = props;
    const dispatch = useDispatch();
    const router = useRouter()

    useEffect(() => {
        if (redirect) {
            dispatch(setAppRedirectStatus(APP_REDIRECT_STATUS.INITIALISED));
        }
    }, [redirect]);

    if (error) {
        router.push('/404')
    }

    if (redirect) {
        router.push(`/${redirect}`)
    }

    if (loading) {
        return null;
    }

    return (
        <>
            <PageHeadOptionalMetaTags />
            {children}
        </>
    );
};

export function withPermalinkRedirection(WrappedComponent, type) {
    return function (props) {
        const [state, setState] = useState({
            loading: true,
            redirect: null,
            error: false,
        })

        useEffect(() => {
            const id = trimLeadingZeros(_.get(props, [ID_VARIABLE[type]]));

            if (id) {
                axios.get(`${API_KEYS.API_URL}/v2/public/${type}/${parseInt(id)}/permalink`).then(
                    response => {
                        const permalink = _.get(response, 'data.data.url', '');
                        setState(prevState => ({
                            ...prevState,
                            redirect: !validatePermalink(permalink, props, type) ? permalink : null,
                            loading: false
                        }));
                    }
                ).catch(error => {
                    setState(prevState => ({
                        ...prevState,
                        error: true,
                        redirect: null,
                        loading: false
                    }));
                });
            }
        }, [])

        const { error, loading, redirect} = state;

        return (
            <PermalinkRedirection
                key={`redirection-${new Date().toISOString()}`}
                error={error}
                redirect={redirect}
                loading={loading}
            >
                <WrappedComponent {...props}/>
            </PermalinkRedirection>
        );
    }
}
